import { rechargeApiRequest, getInternalSession } from '../utils/request.js';

function listAddresses(session, query) {
  return rechargeApiRequest(
    "get",
    `/addresses`,
    { query },
    getInternalSession(session, "listAddresses")
  );
}
async function getAddress(session, id, options) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { address } = await rechargeApiRequest(
    "get",
    `/addresses`,
    {
      id,
      query: { include: options?.include }
    },
    getInternalSession(session, "getAddress")
  );
  return address;
}
async function createAddress(session, createRequest) {
  const { address } = await rechargeApiRequest(
    "post",
    `/addresses`,
    { data: { customer_id: session.customerId ? Number(session.customerId) : void 0, ...createRequest } },
    getInternalSession(session, "createAddress")
  );
  return address;
}
async function updateAddress(session, id, updateRequest, query) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { address } = await rechargeApiRequest(
    "put",
    `/addresses`,
    { id, data: updateRequest, query },
    getInternalSession(session, "updateAddress")
  );
  return address;
}
async function applyDiscountToAddress(session, id, discountCode, query) {
  return updateAddress(
    getInternalSession(session, "applyDiscountToAddress"),
    id,
    {
      discounts: [{ code: discountCode }]
    },
    query
  );
}
async function removeDiscountsFromAddress(session, id, query) {
  if (id === void 0 || id === "") {
    throw new Error("Id is required");
  }
  return updateAddress(getInternalSession(session, "removeDiscountsFromAddress"), id, { discounts: [] }, query);
}
function deleteAddress(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  return rechargeApiRequest("delete", `/addresses`, { id }, getInternalSession(session, "deleteAddress"));
}
async function mergeAddresses(session, mergeRequest) {
  const { address } = await rechargeApiRequest(
    "post",
    `/addresses/merge`,
    {
      data: mergeRequest
    },
    getInternalSession(session, "mergeAddresses")
  );
  return address;
}
async function skipFutureCharge(session, id, skipRequest) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { charge } = await rechargeApiRequest(
    "post",
    `/addresses/${id}/charges/skip`,
    {
      data: skipRequest
    },
    getInternalSession(session, "skipFutureCharge")
  );
  return charge;
}

export { applyDiscountToAddress, createAddress, deleteAddress, getAddress, listAddresses, mergeAddresses, removeDiscountsFromAddress, skipFutureCharge, updateAddress };
//# sourceMappingURL=address.js.map
